// react
import React from 'react';

// third-party
import PropTypes from 'prop-types';
// import { FormattedMessage } from 'react-intl';
//import { Link } from 'react-router-dom';

// application
import NavPanel from './NavPanel';
// import { LogoSvg } from 'svg';

function Header(props) {
    const { layout } = props;
    return (
        <div className="site-header">
            <div className="site-header__nav-panel">
                <NavPanel layout={layout} />
            </div>
        </div>
    );
}

Header.propTypes = {
    /** one of ['default', 'compact'] (default: 'default') */
    layout: PropTypes.oneOf(['default', 'compact']),
};

Header.defaultProps = {
    layout: 'default',
};

export default Header;
